export enum Status {
  Pending = 1,
  Suspended = 3,
  Deleted = 4,
  Confirmed = 5,
  Draft = 6,
  Archived = 7,
  Shortlisted = 8,
  Interviewed = 9,
  Contacted = 10,
  Screened = 11,
  Declined = 12,
  Viewed = 13,
  Approved = 14,
  Rejected = 15,
  Active = 16,
  Inactive = 17,
  Paid = 18,
  Failed = 19,
  OnHold = 20,
  Closed = 21,
  Sent = 22,
  Outbox = 23,
  Inbox = 24,
  Reply = 25,
  Review = 26,
  BeingPosted = 27,
  Posted = 28,
  Considering = 29,
  OfferMade = 30,
  Hired = 31,
  InterviewRequested = 32,
  InterviewBooked = 33,
  BehaviouralRequested = 34,
  Free = 35,
  Cancelled = 36,
  VideoProfileRequest = 37,
  Published = 38,
  AgencyExternalInvitation = 39,
  New = 40,
  AwaitingFeedback = 41,
  ClientConfirmed = 42,
  InReview = 43,
  GdprDeleted = 44,
  ApplicationFormCompleted = 45,
  BehaviouralReportCompleted = 46,
  InterviewCompleted = 47,
  Gdpr = 51,
  JobTemplate = 52,
  Parsed = 53,
  CandidateDatabase = 54,
  Completed = 55,
  Processing = 56,
  OnlineInterview = 57,
  Merged = 58,
  SentToOnboarding = 59,
  OnboardingCompleted = 60,
  OfferDeclined = 61,
  Prospect = 62,
  Expired = 63,
  PartiallyCompleted = 64,
  Scheduled = 101,
  PartiallyLive = 102,
  Reverted = 103,
  CopyWriting = 104,
  Attended = 105,
  Absent = 106,
  Accepted = 107,
}